"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.statusMessages = exports.subjectMessages = exports.Status = exports.Subject = void 0;
const schema_1 = require("../../schema");
var Subject;
(function (Subject) {
    Subject["MEDICAL_PRACTITIONER_COMMENT"] = "MEDICAL_PRACTITIONER_COMMENT";
    Subject["PATIENT_INFO"] = "PATIENT_INFO";
})(Subject || (exports.Subject = Subject = {}));
var Status;
(function (Status) {
    Status["NEW"] = "NEW";
    Status["MEDICAL_EXAMINATION_IN_PROGRESS"] = "MEDICAL_EXAMINATION_IN_PROGRESS";
    Status["DONE"] = "DONE";
    Status["EXIT"] = "EXIT";
})(Status || (exports.Status = Status = {}));
exports.subjectMessages = {
    [Subject.MEDICAL_PRACTITIONER_COMMENT]: {
        id: "basicHealth.patientCondition.subject.MEDICAL_PRACTITIONER_COMMENT",
        defaultMessage: "Kezelőorvos megjegyzése"
    },
    [Subject.PATIENT_INFO]: {
        id: "basicHealth.patientCondition.subject.PATIENT_INFO",
        defaultMessage: "Beteg által közölt információ"
    }
};
exports.statusMessages = {
    [Status.NEW]: {
        id: "basicHealth.patientCondition.status.NEW",
        defaultMessage: "Új"
    },
    [Status.MEDICAL_EXAMINATION_IN_PROGRESS]: {
        id: "basicHealth.patientCondition.status.MEDICAL_EXAMINATION_IN_PROGRESS",
        defaultMessage: "Kivizsgálás folyamatban"
    },
    [Status.DONE]: {
        id: "basicHealth.patientCondition.status.DONE",
        defaultMessage: "Kivizsgálás megtörtént"
    },
    [Status.EXIT]: {
        id: "basicHealth.patientCondition.status.EXIT",
        defaultMessage: "Exit"
    }
};
const subject = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Subject.MEDICAL_PRACTITIONER_COMMENT),
    schema_1.Schema.singleChoiceItem(Subject.PATIENT_INFO)
]);
const description = schema_1.Schema.string().maxLength(10000).interpretation({
    vocab: "basic_health",
    code: "description_of_patient_condition"
});
const status = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Status.NEW),
    schema_1.Schema.singleChoiceItem(Status.MEDICAL_EXAMINATION_IN_PROGRESS),
    schema_1.Schema.singleChoiceItem(Status.DONE),
    schema_1.Schema.singleChoiceItem(Status.EXIT)
])
    .interpretation({ vocab: "basic_health", code: "patient_status" })
    .tag({ vocab: "snomed", code: "224238005" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ subject, description, status })
    .interpretation({ vocab: "basic_health", code: "patient_condition" });
